import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { CareplusCompleteTxRequest } from "src/models/careplus-complete-tx-request";

@Component({
  selector: "app-agency-payment-status",
  templateUrl: "./agency-payment-status.component.html",
  styleUrls: ["./agency-payment-status.component.css"],
})
export class AgencyPaymentStatusComponent implements OnInit {
  private route = inject(ActivatedRoute);

  paymentStatus: string | null = null;
  loading: boolean = true;
  trackId: string | null = null;
  batchId: number | null = null;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const status = params["status"];
      const trackId = params["trackId"];
      const batchId = localStorage.getItem("batch_id");

      if (batchId && status && trackId) {
        localStorage.removeItem("batch_id");
        this.batchId = parseInt(batchId, 10);
        this.trackId = trackId;
        this.paymentStatus = status;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }
}
